import { AppState, PostPageBaliAppState } from '../../initialStateRegistration';

const getPostPage = (state: AppState) => (state as PostPageBaliAppState).template;

export const getShowRecommendationsAdvertisement = (state: AppState) => getPostPage(state).showRecommendationsAdvertisement;

export const getRevcontentWidgetID = (state: AppState) => getPostPage(state).revcontentWidgetID;

export const getRevcontentAMPWidgetID = (state: AppState) => getPostPage(state).revcontentAMPWidgetID;
